// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__63uhW","blog__link":"styles_blog__link__2NIPo","item":"styles_item__OfT-O","item__in":"styles_item__in__iMrbE"};